import { lazy } from "react";
import MenuConfig from "../../../../constants/MenuConfig";

const AppointmentGrowthReport = lazy(() => import("./AppointmentGrowthReport"));
const MonthlyHighlightReport = lazy(() => import("./MonthlyHighlightReport"));

// Uma entrada cadastra o cartão e a rota ao mesmo tempo. Cada relatório mantém seus
// próprios filtros e dados; o catálogo só descreve como encontrá-lo no módulo.
// As páginas carregam sob demanda para o catálogo continuar leve com muitos relatórios.
export const PERFORMANCE_REPORTS = [
    {
        id: "appointment-growth",
        route: MenuConfig.performance.appointment_growth.route,
        titleKey: "performance.reports.appointment_growth",
        descriptionKey: "performance.reports.appointment_growth_hint",
        icon: "fa-solid fa-chart-line",
        Component: AppointmentGrowthReport,
    },
    {
        id: "monthly-highlight",
        route: MenuConfig.performance.monthly_highlight.route,
        titleKey: "performance.reports.monthly_highlight",
        descriptionKey: "performance.reports.monthly_highlight_hint",
        icon: "fa-solid fa-trophy",
        Component: MonthlyHighlightReport,
    },
];
